import React from 'react';
import { motion } from 'framer-motion';
import { technologies } from '../../mock';

const italicTitles = {
  'Radiographie 3D': { lead: 'Radiographie', italic: '3D' },
  'Empreintes Numériques': { lead: 'Empreintes', italic: 'numériques' },
  'Laser Dentaire': { lead: 'Laser', italic: 'dentaire' },
  'Stérilisation Avancée': { lead: 'Stérilisation', italic: 'avancée' },
};

const fadeUp = {
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: '-80px' },
  transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] },
};

export default function TechnologiesV2() {
  return (
    <section id="technologies" className="bg-background py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <motion.div {...fadeUp} className="grid grid-cols-1 md:grid-cols-12 gap-y-6 mb-20 lg:mb-28">
          <div className="md:col-span-3">
            <span className="text-[11px] font-semibold uppercase tracking-[0.3em] text-foreground/55">
              03 — Plateau technique
            </span>
          </div>
          <div className="md:col-span-9">
            <h2 className="font-display text-5xl sm:text-6xl lg:text-7xl leading-[0.9] tracking-tight text-foreground">
              Quatre outils, <span className="italic text-foreground/85">une exigence</span>.
            </h2>
          </div>
        </motion.div>

        <ol className="divide-y divide-foreground/15 border-y border-foreground/15">
          {technologies.map((tech, idx) => {
            const titles = italicTitles[tech.name] || { lead: tech.name, italic: '' };
            return (
              <motion.li
                key={tech.id}
                {...fadeUp}
                className="grid grid-cols-1 md:grid-cols-12 gap-y-3 md:gap-x-8 py-8 lg:py-10 group"
              >
                <div className="md:col-span-1">
                  <span className="font-display text-3xl lg:text-4xl text-foreground/30 leading-none">
                    {String(idx + 1).padStart(2, '0')}
                  </span>
                </div>
                <div className="md:col-span-5">
                  <h3 className="font-display text-3xl sm:text-4xl lg:text-5xl leading-[0.95] tracking-tight text-foreground">
                    {titles.lead}{' '}
                    {titles.italic && (
                      <span className="italic text-foreground/80">{titles.italic}</span>
                    )}
                    .
                  </h3>
                </div>
                <div className="md:col-span-6 flex md:justify-end">
                  <p className="max-w-md text-sm sm:text-base text-foreground/65 leading-relaxed md:text-right">
                    {tech.description}
                  </p>
                </div>
              </motion.li>
            );
          })}
        </ol>
      </div>
    </section>
  );
}
